module.exports = __webpack_public_path__ + "img/slide4-ru.16e97cf1.png";